import styled from '@emotion/styled'

import { Disclaimer } from './Disclaimer'
import { Locals, type LocalsProps } from './Locals'

export interface AgenciesProps {
  disclaimer?: string
  agencies: LocalsProps[]
}

const AgenciesStyles = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0 1rem',
})

const Agencies = ({ agencies, disclaimer }: AgenciesProps) => (
  <AgenciesStyles className="ecs-container">
    {!!disclaimer && <Disclaimer disclaimer={disclaimer} />}
    {agencies.map((agency, index) => (
      <Locals key={`${index}-${agency.id}`} {...agency} />
    ))}
  </AgenciesStyles>
)

export default Agencies
